import { UnitSelect } from 'components/template/TemplateForm';
import { TimeInput } from 'components/template/TemplateForm';
import { RateInput } from 'components/template/TemplateForm';
import moment from 'moment';
import React from 'react'
import { Controller } from 'react-hook-form';
const RatesSection = ({ title, control, errors, prefix }) => {
    return (
        <div className='row-primary rate_container_outer'>
            <h2 className='fw-bold text-uppercase'>{title}</h2>
            <div className='w-100'>
                {['normal', 'after'].map((time) => (
                    <div key={time} className='rate_container_wrapper'>
                        <h2 className='text-center my-3 fw-bold fst-italic'>{time === 'normal' ? 'Normal Hours' : 'After Hours'}*</h2>

                        <div className="template_create rate_container">
                            <div className="row-primary align-items-end inner">
                                <h2 className='mb-3 my-0'>Rates:</h2>
                                {['opi_vri', 'inperson'].map((type) => (
                                    <div className='Inter_rate_row' key={type}>
                                        <h4>{type === 'opi_vri' ? 'OPI/VRI' : 'In Person'}</h4>
                                        <div className='create inter_wrapper'>
                                            <RateInput control={control} name={`${prefix}_${type}_${time}_rate`} placeholder={`${type === 'opi_vri' ? 'OPI/VRI' : 'In Person'} rate`} currency_symbol={true} />
                                            <UnitSelect control={control} name={`${prefix}_${type}_${time}_rate_time_unit`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row-primary align-items-end inner">
                                <h2 className='mb-3 my-0'>Minimum:</h2>
                                {['opi_vri', 'inperson'].map((type) => (
                                    <div className='Inter_rate_row' key={type}>
                                        <div className='create inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`${prefix}_${type}_${time}_min`} placeholder={`${type === 'opi_vri' ? 'OPI/VRI' : 'In Person'} minimum`} />
                                            <UnitSelect control={control} name={`${prefix}_${type}_${time}_min_time_unit`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};



const InterpreterRateSection = ({ control, errors, watch, ErrorMessage, setValue }) => {
    const handleNormalHoursChange = () => {
        const normalHourStartTime = watch("normal_hour_start_time");
        const normalHourEndTime = watch("normal_hour_end_time");

        if (normalHourStartTime && normalHourEndTime) {
            const normalStart = moment(normalHourStartTime, "HH:mm");
            const normalEnd = moment(normalHourEndTime, "HH:mm");

            const afterStart = moment(normalEnd).add(1, "minutes");
            const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

            setValue("after_hour_start_time", afterStart.format("HH:mm"));
            setValue("after_hour_end_time", afterEnd.format("HH:mm"));
        }
    };

    const handleAfterHoursChange = () => {
        const afterHourStartTime = watch("after_hour_start_time");
        const afterHourEndTime = watch("after_hour_end_time");

        if (afterHourStartTime && afterHourEndTime) {
            const afterStart = moment(afterHourStartTime, "HH:mm");
            const afterEnd = moment(afterHourEndTime, "HH:mm");

            const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
            const normalEnd = moment(afterStart).subtract(1, "minutes");

            setValue("normal_hour_start_time", normalStart.format("HH:mm"));
            setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
        }
    };
    return (
        <>
            <hr />
            {/* Normal Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>Normal Hours </h2>
            </div>
            <div className="foam_page_row">
                <div className="row-primary">
                    <h2>Start Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_start_time"
                        rule="Please select start time"
                        onChange={handleNormalHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>End Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_end_time"
                        rule="Please select End time"
                        onChange={handleNormalHoursChange}
                    />
                </div>
            </div>

            {/* After Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>After Hours </h2>
            </div>
            <div className="foam_page_row">
                <div className="row-primary">
                    <h2>Start Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_start_time"
                        rule="Please select start time"
                        onChange={handleAfterHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>End Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_end_time"
                        rule="Please select End time"
                        onChange={handleAfterHoursChange}
                    />
                </div>
            </div>


            {/* Grace Period */}
            <div className='foam_page_row mt-3'>
                <div className="row-primary">
                    <h2>Cancellation Grace Period(Hrs)</h2>
                    <div style={{ width: "100%" }}>
                        <Controller
                            name="grace_period"
                            control={control}
                            rules={{ required: "Please enter Grace Period" }}
                            render={({ field }) => (
                                <input className="input-in type_inp"
                                    type="number"
                                    name='grace_period'
                                    placeholder='Grace Period' required
                                    {...field}
                                    onChange={
                                        (e) => {
                                            field.onChange(parseFloat(e.target.value));
                                            if (e.target.value < 0) {
                                                field.onChange(0);
                                            }
                                        }
                                    }
                                />
                            )}
                        />
                        {errors?.grace_period?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.grace_period?.message} /></div>}
                    </div>
                </div>
            </div>
            <div className="row-primary mt-3 mb-5 justify-content-center">
                <h2 className="fw-bold text-center text-uppercase">Rates</h2>
            </div>
            <RatesSection title='General Rates' control={control} errors={errors} prefix='general' />
            <RatesSection title='Court Rates' control={control} errors={errors} prefix='court' />
        </>
    )
}

export default InterpreterRateSection